export default "__VITE_ASSET__DRjxX1B6__"